export const FEATURE_BRANDING = 'branding';
export const FEATURE_EMOJI_RESTRICTIONS = 'emoji-restrictions';
export const FEATURE_PAYWALL = 'paywall';
export const FEATURE_KEY_SELLING_POINTS = 'key-selling-points';
export const FEATURE_LINKOUT = 'linkout';
export const FEATURE_MANDATORY_QUESTIONS = 'mandatory-questions';
export const FEATURE_PER_UNIT_BILLING = 'per-unit-billing';
export const FEATURE_PRIVATE_AD = 'private-ad';
export const FEATURE_PSEUDO_LOCALISATION = 'pseudo-localisation';
export const FEATURE_RECOMMENDED_CANDIDATE_PANEL =
  'recommended-candidate-panel';
export const FEATURE_SPONSORED_SLOT = 'sponsored-slot';
export const FEATURE_CART_EDIT_FLOW = 'cart-edit-flow';
